import {ForecastTheme, tokensForThemeProvider} from '@forecast-it/design-system';
import PropTypes from 'prop-types';
import React from 'react';
import {DefaultTheme, ThemeProvider} from 'styled-components';
import {theme as webComponentsTheme} from '@/web-components';
import {MODULE_TYPES} from '../../constants';
import {hasModule} from './util/ModuleUtil';
import {isSageSpecificUrl} from './util/UrlUtil';

const getThemeName = (): ForecastTheme => {
	if (hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
		return ForecastTheme.Sage;
	}
	if (isSageSpecificUrl()) {
		return ForecastTheme.Sage;
	}
	return ForecastTheme.Sky;
};

export interface ForecastThemeProviderProps {
	children: JSX.Element;
}

export const ForecastThemeProvider = ({children}: ForecastThemeProviderProps): JSX.Element => {
	const themeName = getThemeName();
	const combinedTheme: DefaultTheme = {
		themeName,
		...webComponentsTheme,
		...tokensForThemeProvider[themeName],
	};
	return <ThemeProvider theme={combinedTheme}>{children}</ThemeProvider>;
};

ForecastThemeProvider.propTypes = {
	children: PropTypes.any,
};
